<template>
    <div>
        <div id="myNav" class="overlay">

        <!-- Button to close the overlay navigation -->
        <a href="javascript:void(0)" class="closebtn" v-on:click="closeNav">&times;</a>

        <!-- Overlay content -->
        <div class="overlay-content">
            <a href="/" v-on:click="closeNav">HOME</a>
            <a href="/portfolio" v-on:click="closeNav">PORTFOLIO</a>
            <!-- <a href="/works" v-on:click="closeNav">WORKS</a> -->
            <a href="/instagram" v-on:click="closeNav">INSTAGRAM</a>
            <!-- <a href="/giama" v-on:click="closeNav">GIAMA</a> -->
            <!-- <a href="https://www.creativehublucca.com/" v-on:click="closeNav">CREATIVEHUB</a> -->
            <a href="/contacts" v-on:click="closeNav">CONTACTS</a>
        </div>

        </div>

        <!-- Use any element to open/show the overlay navigation menu -->
        
        <div class="headhover"><a href="/"><img class="logo" src="../../assets/imgs/base/icon_piccola_white.png" alt=""></a></div>
            
        <div class="open" id="MyOpen">
            <a href="javascript:void(0)" v-on:click="openNav">
                <div class="nav-icon" >
                    <div></div>
                </div>
            </a>
        </div>
            
    </div>
</template>

<script>
export default {
    name: 'Navbar',
    components :{
    },
    mounted() {
    },
    methods: {
        preventDefault(e){
                e.preventDefault();
        },
        openNav() {
            document.getElementById("myNav").style.width = "100%";
            document.body.classList.add("noscroll");
            document.getElementById("MyOpen").style.display = "none";
            document.body.addEventListener('touchmove', this.preventDefault, { passive: false });       
        },
        closeNav() {
            document.getElementById("myNav").style.width = "0%";
            document.body.classList.remove("noscroll");
            document.getElementById("MyOpen").style.display = "block";
            document.body.removeEventListener('touchmove', this.preventDefault, { passive: false });
        }
    }
}
</script>

<style scoped>
    @import url('./Navbar.css');
</style>
